import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import App from './App';
import './index.css';

// Create root container
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

// Detect Language from URL or Browser
const currentPath = window.location.pathname;
const pathParts = currentPath.split('/');
const supportedLangs = ['ar', 'en'];
const urlLang = pathParts[1] && supportedLangs.includes(pathParts[1]) ? pathParts[1] : '';

// If no URL lang, check browser language and auto-redirect
if (!urlLang) {
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  const primary = browserLang.split('-')[0].toLowerCase();
  if (primary === 'ar') {
    window.location.replace(`/ar${currentPath === '/' ? '' : currentPath}`);
  }
}

const basename = urlLang ? `/${urlLang}` : '/';

// Render app
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  </React.StrictMode>
); 
